import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { UpdateLLMConversationMutation } from "../API";
import { updateLLMConversation } from "../graphql/mutations";

export async function updateConversationCustomer(
  conversationId: string,
  customerId: string | null
): Promise<GraphQLResult<UpdateLLMConversationMutation>> {

  return API.graphql(
    graphqlOperation(updateLLMConversation, {
      input: {
        id: conversationId,
        customerId: customerId || undefined,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMConversationMutation>>;
}
